<template>
    <div class="upgradeTableTotal">
        <template v-for="(item) in tableFiltered">
            <div
                class="columns"
                :class="classesColumns(item)"
            >
                <div
                    class="column column__first upgradeTableTotal__label"
                    :class="classesColumn(item)"
                >
                    <template v-if="item.typeColumn === 'normal' || item.typeColumn === 'total'">
                        {{ item.label }}
                    </template>
                    <template v-if="item.typeColumn === 'small' || item.typeColumn === 'footer'">
                        <small
                            @click="handleCollapse(item)"
                        >
                            {{ item.label }}
                        </small>
                    </template>

                    <div class="upgradeTableTotal__icon">
                        <fa-icon
                            v-if="item.tooltip"
                            :icon="['fas', 'info-circle']"
                            :tooltip="{
                                placement: 'right',
                                content: item.tooltip
                            }"
                        />
                    </div>

                    <span
                        v-if="!item.isCard && item.typeDefault.includes('annual')"
                        class="upgradePlanItem__note"
                        style="text-align: left;"
                    >
                        <sup>*</sup>Billed annually
                    </span>
                </div>

                <div
                    v-if="item.total"
                    class="column is-3 has-text-right upgradeTableTotal__label"
                >
                    {{ item.total }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        table: { type: Array, default: () => [] },
    },

    data() {
        return {
            tableFiltered: [],
            isCollapsed: true,
        };
    },

    methods: {
        classesColumns(item) {
            return {
                'upgradeTableTotal__total': item.typeColumn === 'total',
                'upgradeTableTotal__item': item.typeColumn === 'small',
                'upgradeTableTotal__item--last': item.isLast,
                'is-marginless': item.typeColumn === 'small' || item.typeColumn === 'normal' || item.typeColumn === 'footer',
                'is-small-marginless': item.typeColumn === 'small',
                'upgrade-plan__amount': item.typeColumn === 'total',
                'card-footer': item.typeColumn === 'footer',
                'toggle-button': item.type === 'collapse-button',
                'collapsed': item.type === 'collapse-button' && this.isCollapsed,
            };
        },

        classesColumn(item) {
            return {
                'is-9': item.typeColumn !== 'footer',
            };
        },

        handleCollapse(item) {
            if (item.type === 'collapse-button') {
                if (this.isCollapsed) {
                    this.tableFiltered = this.table;
                } else {
                    this.tableFiltered = this.table.filter(item => item.type !== 'collapsed');
                }

                this.isCollapsed = !this.isCollapsed;
            }
        }
    },
    mounted() {
        this.tableFiltered = this.table.filter(item => item.type !== 'collapsed');
    }
};
</script>

<style lang="scss" scoped>
@import "./styles.module.scss";
</style>
